<template>
  <Layout>
    <router-view/>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'

import Layout from '@/router/layouts/main'

export default {
  page: {
    title: 'Delivery Request',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
  },
}
</script>
